


















































    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import TablePager from '@/components/TablePager.vue';
    import TableField from '@/types/TableField';
    import TableSortEventArgs from '@/types/TableSortEventArgs';
    import PagerOptions, { InitPagerOptions } from '@/types/PagerOptions';
    import SortOptions from '@/types/SortOptions';
    import EntityReference from '@/types/EntityReference';
    import { BTable, BButton, BIconArrowUp, BIconArrowDown, BSpinner } from 'bootstrap-vue';
    import RoleFilterOptions from '@/types/RoleFilterOptions';
    import Configuration from '@/types/Configuration';
    import InlineSvg from 'vue-inline-svg';
    import ColumnHeader from '@/components/ColumnHeader.vue';
    import AxiosService from '@/services/axiosService';
    import i18n from '../i18n';

    @Component({
        components: {
            'table-pager': TablePager,
            'b-table': BTable,
            'b-btn': BButton,
            'b-icon-arrow-up': BIconArrowUp,
            'b-icon-arrow-down': BIconArrowDown,
            'inline-svg': InlineSvg,
            'column-header': ColumnHeader,
            'b-spinner': BSpinner
        }
    })
	export default class RoleList extends Vue {
        @Prop() refresh!: boolean
        @Prop() filter!: RoleFilterOptions

        roles: RoleListItem[] = [];
        listOptions: RoleListOptions = {
            filter: this.filter,
            pagerOptions: {
                page: 1,
                pageSize: Configuration.DefaultPageSize,
                pageCount: 1,
                rowCount: 0,
                rowStart: 0,
                rowEnd: 0
            },
            sortOptions: {
                sortBy: 'name',
                sortDirection: Configuration.SortDirectionAscending
            }
        };
        isBusy = false;
        apiAccessToken = this.$store.state.apiAccessToken;

        fields: TableField[] = [
            {
                key: 'sequenceId',
                label: 'fields.id',
                headerTitle: 'Id',
                sortable: true,
                thStyle: 'width: 75px',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg py-4',
                formatter: null
            },
			{
                key: 'name',
                label: 'fields.name',
                headerTitle: 'Name',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg py-4',
                formatter: null
            },
			{
                key: 'isActive',
                label: 'fields.status',
                headerTitle: 'Status',
                sortable: true,
                thStyle: 'width: 100px',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: (value: boolean) => { return 'pt-5 pb-4 text-nowrap' + (value ? ' text-success' : ' text-danger'); },
                formatter: (value: boolean) => { return value ? 'status.active' : 'status.inactive'; }
            },
            {
                key: 'actions',
                label: '',
                headerTitle: '',
                sortable: false,
                thStyle: 'width: 110px',
                thClass: 'columnheader',
                tdClass: 'pl-3 pr-1 py-4 text-right',
                formatter: null
            }
        ];

        @Watch('refresh')
        refreshList(newVal: boolean) {
            if (newVal) {
                this.loadRoles();
            }
        }

        @Watch('filter')
        filterList(newVal: RoleFilterOptions) {
            this.listOptions.filter = newVal;
            this.listOptions.pagerOptions.page = 1;
        }

        mounted() {
            this.isBusy = false;
            this.apiAccessToken = this.$store.state.apiAccessToken;
            this.loadRoles();
        }

        async loadRoles() {
            //this.isBusy = true;
            this.listOptions.pagerOptions.pageSize = 0;

            try {
                const response = await AxiosService.request<ServerData>({
                    url: `rolesadministration/list`,
                    method: 'POST',
                    data: this.listOptions
                });

                this.roles = response.data.records ?? [];
                this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, 1, 1, response.data.totalRecordCount);
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
                this.$emit('load-complete');
            }
        }

        editRole(id: string) {
            this.$emit('role-selected', id);
        }

        async deleteRole(id: string) {
            try {
                const response = await AxiosService.request({
                    url: `rolesadministration/candelete/${id}`,
                    method: 'GET'
                });

                const canDelete = response.data.canDelete;

                const role = this.roles.find(x => x.id == id);

                if (!canDelete) {
                    this.$bvModal.msgBoxOk(
                        this.$t('modal.deniedRoleDeleteMessage', { roleName: role?.name }) as string, {
                            title: this.$t('modal.deniedRoleDeleteTitle') as string,
                            centered: true,
                            buttonSize: 'sm',
                            okTitle: this.$t('modal.closeModal') as string
                        }
                    );
                    return;
                }

                this.$bvModal.msgBoxConfirm(this.$t('modal.confirmRoleDeleteMessage', { roleName: role?.name }) as string, {
                        title: this.$t('modal.confirmRoleDeleteTitle') as string,
                        centered: true,
                        buttonSize: 'sm',
                        okTitle: this.$t('modal.confirmOkTitle') as string,
                        cancelTitle: this.$t('modal.confirmCancelTitle') as string
                    })
                    .then(value => {
                        if (value) {
                            try {
                                AxiosService.request<ServerData>({
                                    url: `rolesadministration?id=${id}`,
                                    method: 'DELETE'
                                });

                                this.$root.$bvToast.toast(this.$t('toaster.roleDeleted', { roleName: role?.name }) as string, {
                                    title: this.$t('toaster.deleteRoleTitle') as string,
                                    autoHideDelay: Configuration.ToasterAutoHideDelay,
                                    appendToast: true,
                                    variant: Configuration.ToasterVariantSuccess,
                                    toaster: Configuration.ToasterPosition
                                });
                                this.loadRoles();
                            }
                            catch (error) {
                                if (error.response) {
                                    switch (error.response.status) {
                                        case 404:
                                            return this.$router.push(`/${i18n.locale}/notfound`);
                                        case 403:
                                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                                        default:
                                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                                    }
                                }
                            }
                            finally {
                                this.isBusy = false;
                            }
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
            }
        }

        onChangePage(page: number) {
            this.listOptions.pagerOptions.page = page;
            this.loadRoles();
        }

        onChangePageSize(pageSize: number) {
            this.listOptions.pagerOptions.pageSize = pageSize;
            this.listOptions.pagerOptions.page = 1;
            this.loadRoles();
        }

        onSortChanged(e: TableSortEventArgs) {
            this.listOptions.sortOptions.sortBy = e.sortBy;
            this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
            this.loadRoles();
        }
	}

	interface ServerData {
        records: RoleListItem[];
        totalRecordCount: number;
        pageCount: number;
	}

    interface RoleListItem {
        id: string;
        sequenceId: number;
        name: string;
        projects: EntityReference[];
        isActive: boolean;
        actions: string;
    }

    interface RoleListOptions {
        filter: RoleFilterOptions;
        pagerOptions: PagerOptions;
        sortOptions: SortOptions;
    }
